import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LookupCountInterface } from '../../models/dashboard/dashboard/lookup-count';

interface IInitialState {
  lookupCountData?: LookupCountInterface;
}

const initialState: IInitialState = {
  lookupCountData: undefined,
};

const lookupCountSlice = createSlice({
  name: 'lookupCountSlice',
  initialState,
  reducers: {
    setLookupCountData(state, action: PayloadAction<LookupCountInterface>) {
      state.lookupCountData = action.payload;
    },
  },
});

export const lookupCountActions = lookupCountSlice.actions;
export default lookupCountSlice.reducer;
